import {createSlice} from '@reduxjs/toolkit';
import { StepTitle } from 'semantic-ui-react';


const userStorage=()=>{
    if(localStorage.getItem('user')!==null){
        return JSON.parse(localStorage.getItem('user'));
    }else{
        return null;
    }
    
}

export const userSlice = createSlice({
    name:"user",
    initialState:{
        userStorage
    },
    reducers:{
        login: (state,action) => {
            state.user=action.payload;
            localStorage.setItem('user', JSON.stringify(state));
        },
        logout:(state)=>{
            localStorage.removeItem('user');
            state.user=null;
        }
     }
})

export const {login,logout} =userSlice.actions;
export const selectUser = (state)=> state.user.user;
export default userSlice.reducer;
